// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, DispatchResetOrderApprovals, SendTracking } from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { xGoogleAnalyticsState } from "@werner/App/GoogleAnalyticsConnector/Store/Reducers";
import { getDataLayer } from "@werner/App/GoogleAnalyticsConnector/Utilities/DataLayer";
import { generateMultipleCategories } from "@werner/App/GoogleAnalyticsConnector/Utilities/generateMultipleCategories";

export const XngGaSendTracking: typeof DispatchResetOrderApprovals = props => {
    const state = props.getState() as xGoogleAnalyticsState;
    const updatedCart = { ...props.cartToUpdate, orderNumber: props.apiResult.cart.orderNumber };
    const session = getSession(props.getState());
    
    if (state.xGoogleAnalytics.purchaseEvent) {
        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }
        const { apiResult } = props;

        const googleAnalyticsData = {
            event: state.xGoogleAnalytics.purchaseEventName,
            ecommerce: {
                transaction_id: apiResult.cart.orderNumber,
                value: apiResult.cart.orderSubTotal,
                tax: apiResult.cart.totalTax,
                shipping: apiResult.cart.shippingAndHandling,
                currency: session.currency?.currencyCode,
                coupon: apiResult.cart.promotionCode,
                affiliation: state.xGoogleAnalytics?.affiliation,
                account_info: {
                    userId: getSession(props.getState()).userProfileId,
                    salesRepName: apiResult.cart?.salespersonName,
                },
                items: updatedCart.cartLines?.map((cartLine, idx) => {
                    const categoryFields = generateMultipleCategories(cartLine.properties?.["categories"]);
                    return {
                        item_id: cartLine.erpNumber,
                        item_name: cartLine.shortDescription,
                        affiliation: state.xGoogleAnalytics?.affiliation,
                        coupon: apiResult.cart.promotionCode,
                        discount: cartLine.pricing 
                            ? cartLine.pricing.unitNetPrice < cartLine.pricing.unitListPrice 
                                ? cartLine.pricing.unitListPrice - cartLine.pricing.unitNetPrice 
                                : 0 
                            : 0,
                        index: idx,
                        item_brand: state.xGoogleAnalytics.includeProductBrand 
                            ? cartLine.brand?.name || "" 
                            : undefined,
                        item_list_id: state.xGoogleAnalytics.includeProductCategory 
                            ? cartLine.properties?.["categoryId"] || "" 
                            : undefined,
                        locationId: session.pickUpWarehouse?.id,
                        price: cartLine.pricing?.unitNetPrice,
                        quantity: cartLine.qtyOrdered,
                        ...(state.xGoogleAnalytics.includeProductCategory && categoryFields), // Spread dynamic category fields
                    };
                }),
            },
        };        

        dataLayer.push(googleAnalyticsData);
    }
};

addToChainAfter(chain, SendTracking, XngGaSendTracking);